import { useEffect, useState } from "react";
import axios from "axios";
async function downloadAdminFile(key, path, name) {
  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/autofundraiser${path}`, { headers: { 'X-Auto-Fundraiser-Admin': key }, responseType: 'blob' });
  const url = URL.createObjectURL(response.data); const link = document.createElement('a'); link.href = url; link.download = name; link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
}
import { readableBrandColor } from "./brandingColors";

const API = process.env.REACT_APP_BACKEND_URL + "/api/autofundraiser";
const errorText = (err) => typeof err.response?.data?.detail === "string" ? err.response.data.detail : (!err.isAxiosError && err.message) || "Check your organization colors and cover wording, then try saving again.";

export default function StrategyBrandingPanel({ adminKey, leadId, organization }) {
  const [brand, setBrand] = useState(null);
  const [revision, setRevision] = useState(0);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [status, setStatus] = useState("");
  const config = { headers: { "X-Auto-Fundraiser-Admin": adminKey } };
  const load = async () => {
    const { data } = await axios.get(API + "/admin/leads/" + leadId + "/branding", config);
    setBrand(data.branding); setRevision(data.revision);
  };
  useEffect(() => { setBrand(null); load().catch((err) => setError(errorText(err))); }, [leadId, adminKey]);
  const save = async (ai) => {
    setBusy(true); setError(""); setStatus("");
    try {
      if (ai) {
        const { data } = await axios.post(API + "/admin/leads/" + leadId + "/branding/generate", { ...brand, revision }, config);
        if (data.generation_job) {
          const deadline = Date.now() + 600000;
          let done = false;
          while (Date.now() < deadline) {
            const response = await axios.get(API + "/admin/branding-jobs/" + data.generation_job.job_id, config);
            if (response.data.status === "failed") throw new Error(response.data.error);
            if (response.data.status === "completed") { done = true; break; }
            await new Promise((resolve) => setTimeout(resolve, 1200));
          }
          if (!done) throw new Error("Your branding request is saved. Reopen this review to check it.");
        }
      } else {
        await axios.put(API + "/admin/leads/" + leadId + "/branding", { ...brand, revision }, config);
      }
      await load(); setStatus(ai ? "AI presentation saved using your selected organization colors. Review the title and subtitle below." : "Organization branding saved.");
    } catch (err) { setError(errorText(err)); } finally { setBusy(false); }
  };
  if (!brand) return <p role="status">{error || "Opening organization branding…"}</p>;
  return <details className="af-branding-panel">
    <summary>BRAND THIS ORGANIZATION'S STRATEGY</summary>
    <p>Choose the organization's colors yourself. AI can suggest the cover wording using those colors; your strategy decisions stay intact.</p>
    <fieldset disabled={busy} className="af-profile-form">
      {brand.logo_data && <img alt="Organization logo" src={brand.logo_data} style={{maxWidth:180,maxHeight:90}} />}
      <label>Organization logo<input type="file" accept="image/png,image/jpeg,image/webp" onChange={async(e)=>{const file=e.target.files[0];if(!file)return;setBusy(true);try{const form=new FormData();form.append('file',file);await axios.post(API+'/admin/leads/'+leadId+'/branding/logo',form,config);await load();setStatus('Organization logo saved.');}catch(err){setError(errorText(err));}finally{setBusy(false);}}} /></label>
      <label>Organization primary color<input type="color" value={brand.primary_color} onChange={(e) => setBrand({ ...brand, primary_color: e.target.value })} /><span>{brand.primary_color}</span></label>
      <label>Organization accent color<input type="color" value={brand.accent_color} onChange={(e) => setBrand({ ...brand, accent_color: e.target.value })} /><span>{brand.accent_color}</span></label>
      <label>Plan cover title<input value={brand.cover_title} onChange={(e) => setBrand({ ...brand, cover_title: e.target.value })} /></label>
      <label>Plan cover subtitle<textarea rows={2} value={brand.subtitle} onChange={(e) => setBrand({ ...brand, subtitle: e.target.value })} /></label>
    </fieldset>
    <div className="af-brand-preview" style={{ borderTopColor: brand.primary_color, borderBottomColor: brand.accent_color }}>
      <span>{organization}</span><h3 style={{ color: readableBrandColor(brand.primary_color) }}>{brand.cover_title || "Your Organization’s Fundraising Strategy"}</h3><p>{brand.subtitle || "A clear direction for the mission you believe in."}</p>
    </div>
    <div className="af-button-row">
      <button className="af-secondary" disabled={busy} onClick={() => save(false)}>SAVE ORGANIZATION BRANDING</button>
      <button className="af-primary" disabled={busy} onClick={() => save(true)}>{busy ? "PREPARING…" : "USE AI TO BRAND THIS PLAN"}</button>
      <button className="af-secondary" disabled={busy} onClick={() => downloadAdminFile(adminKey, "/admin/leads/" + leadId + "/branding/preview", "Branded-Strategy-Preview.html").catch((err) => setError(errorText(err)))}>PREVIEW BRANDED STRATEGY</button>
    </div>
    <small>The AI button uses your configured generation credits. Save private edits and branding before downloading the full preview. Open the plan to print or save as PDF.</small>
    {status && <p role="status">{status}</p>}{error && <p role="alert" className="af-error">{error}</p>}
  </details>;
}
